/* eslint-disable no-undef */
import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { advSearchFilterPopupState } from 'Stores/advSearchFIlterPopup';
import { advSearchState } from 'Stores/advSearch';
import advSearchFiltersState from 'Stores/advSearchFilters';
import userDetail from 'Stores/userDetail';
import { Utils } from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import LoadingWrapper from 'Components/common/loadingWrapper';
import { ReactComponent as LockIcon } from 'Assets/svg/lock.svg';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import { ReactComponent as DropDownIcon } from 'Assets/svg/down-arrow-icon.svg';
import { ReactComponent as InfoIcon } from 'Assets/svg/info-icon.svg';
import Button from 'Components/common/Button';
import { CompanyName } from './companyName';
import { EmpCount } from './empCount';
import { ContactPerCompany } from './contactPerCompany';
import { Revenue } from './revenue';
import { IncludeCompanyCSV } from './includeCompanyCSV';
import { ExcludeCompanyCSV } from './excludeCompanyCSV';
import { LeadName } from './leadName';
import { LeadTitle } from './leadTitle';
import { EmailPreference } from './emailPreference';
import { Options } from './options';
import { PhoneCoverageFilter } from './phoneCoverageFilter';
import { AppliedFiltersPopup } from '../appliedFiltersPopup';
import { Location } from './location';
import { LocationPreference } from './locationPreference';

import { CompanyKeyword } from './companyKeyword';
import { IndustrySectorSearch } from './industrySectorSearch';
import { Technologies } from './technologies';
import FilterDropdown from './filterDropdown';

class ContactFilterPopupState {
  @observable showPopup = false;

  @action
  setShowPopup = (val, byCancel) => {
    this.showPopup = val;
    if (val) advSearchFilterPopupState.setPageStateToPopup();
    if (byCancel) advSearchFilterPopupState.setPreviousState();
  };
}
const contactFilterPopupState = new ContactFilterPopupState();

const ContactFilterPopup = observer(props => {
  const [showFileView, setShowFileView] = React.useState('');
  const {
    LOCATION_PREFERENCE = false,
    CONTACT_PER_COMPANY_FILTER = false,
    ADVANCED_FILTERS = false,
    MOBILE_NUMBER_FILTER = false,
    DIRECT_DIAL_FILTER = false,
    ANY_PHONE_NUMBER_FILTER = false,
  } = userDetail.featureFlags;

  const confirmClick = () => {
    const localCurrIndustrySearchPop = Utils.getLocalStorage(
      'popupIndustrySearch',
    );
    if (localCurrIndustrySearchPop !== null)
      Utils.setLocalStorage('showIndustrySearch', localCurrIndustrySearchPop);
    advSearchFilterPopupState.applyPopupFilters();
  };

  const closeFileMask = () => {
    if (document !== undefined)
      document
        .getElementsByClassName('left-section')[0]
        .classList.remove('stop-scroll');
    setShowFileView('');
  };

  const clearAllFilter = () => {
    advSearchFilterPopupState.clearAllFilters();
  };

  const showAppFilter =
    Object.keys(advSearchFilterPopupState.appliedFilterSectionData).length > 0
      ? Object.keys(advSearchFilterPopupState.appliedFilterSectionData)
          .length === 1 &&
        advSearchFilterPopupState.appliedFilterSectionData.industrySectors !==
          undefined &&
        !advSearchFilterPopupState.appliedFilterSectionData.industrySectors
          .isAllIndustry &&
        !advSearchFilterPopupState.appliedFilterSectionData.industrySectors
          .industries
        ? // eslint-disable-next-line no-unneeded-ternary
          false
        : true
      : false;

  const handleUpgrade = () => {
    Utils.upgradeNowClick('Advanced Filters');
  };

  return contactFilterPopupState.showPopup ? (
    <>
      <div className="contact-filter-popup common-popup">
        <div className="popup-wrap">
          <div className="title title-wrap">
            <div className="title-text">Filters</div>
            {showAppFilter && (
              <div className="title-results">
                <div className="results">
                  {advSearchFilterPopupState.resultLoading ? (
                    <div className="result-loading-wrap">
                      <LoadingWrapper show position="absolute" />
                    </div>
                  ) : advSearchFilterPopupState.resultStatusMsg ===
                    'one_more' ? (
                    <div className="one-more-criteria">
                      <InfoIcon className="info-icon" width={18} height={18} />
                      Please select at least one more search criteria
                    </div>
                  ) : (
                    <>
                      {Utils.usNumberFormat(
                        advSearchFilterPopupState.searchResultCount,
                      )}
                      &nbsp;
                      {advSearchFilterPopupState.searchResultCount > 1
                        ? 'contacts'
                        : 'contact'}
                      {advSearchFilterPopupState.uniqueCompanyCount > 0 && (
                        <>
                          &nbsp;from&nbsp;
                          {Utils.usNumberFormatForCompanyCount(
                            advSearchFilterPopupState.uniqueCompanyCount,
                          )}
                          &nbsp;
                          {advSearchFilterPopupState.uniqueCompanyCount > 1
                            ? 'companies'
                            : 'company'}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            )}
          </div>

          {showAppFilter && <AppliedFiltersPopup />}
          <div
            className={`popup-content-wrap ${showAppFilter ? 'add-top' : ''}`}
          >
            <div
              className={`filter-wrap ${
                !ADVANCED_FILTERS ? ' disabled-filter-wrap' : ''
              }`}
            >
              <div className="section-wrap">
                <div className="section-title-wrap">
                  <div className="title">Location Filters</div>
                </div>
                <div className="section-filters">
                  <div className="filter-item">
                    <Location placeholderText="Location" />
                  </div>
                  {LOCATION_PREFERENCE && (
                    <div className="filter-item">
                      <LocationPreference />
                    </div>
                  )}
                </div>
              </div>

              <div className="section-wrap">
                <div className="section-title-wrap">
                  <div className="title">Industry Filters</div>
                </div>
                <div className="section-filters">
                  <div className="filter-item">
                    <IndustrySectorSearch parentSelectorId="contactTabPopup" />
                  </div>
                  {userDetail.featureFlags.INDUSTRY_CLASSIFICATION_FILTER && (
                    <>
                      <div className="filter-item">
                        <FilterDropdown
                          placeholderText="SIC code"
                          suggestionKey="sicCodeV2"
                          listValues={
                            advSearchFiltersState.filterListValues.sicCode
                          }
                        />
                      </div>
                      <div className="filter-item">
                        <FilterDropdown
                          placeholderText="NAICS code"
                          suggestionKey="naicsCodeV2"
                          listValues={
                            advSearchFiltersState.filterListValues.naicsCode
                          }
                        />
                      </div>
                    </>
                  )}
                  <div className="filter-item">
                    <CompanyKeyword
                      placeHolderText="Keyword"
                      isIncludeExcludeEnabled
                    />
                  </div>
                </div>
              </div>

              <div className="disabled-info-wrap">
                <span onClick={handleUpgrade}>Upgrade now</span> to use
                20+awesome filters to slice and dice your target market.{' '}
              </div>

              <div className="disabled-filters">
                <div className="upgradePopupMask" onClick={handleUpgrade} />
                <div className="section-wrap">
                  <div className="section-title-wrap">
                    <div className="title">
                      Contact Filters
                      <LockIcon className="dropdown-icon plus-icon lock-icon" />
                    </div>
                  </div>
                  <div className="section-filters">
                    <div className="filter-item">
                      <LeadName />
                    </div>
                    <div className="filter-item">
                      <FilterDropdown
                        placeholderText="Level"
                        suggestionKey="level"
                        listValues={
                          advSearchFiltersState.filterListValues.level
                        }
                      />
                    </div>
                    <div className="filter-item">
                      <FilterDropdown
                        placeholderText="Department"
                        suggestionKey="dept"
                        listValues={
                          advSearchFiltersState.filterListValues.department
                        }
                      />
                    </div>
                    <div className="filter-item">
                      <LeadTitle allowExcludeFilter />
                    </div>
                  </div>
                </div>
                <div className="section-wrap">
                  <div className="section-title-wrap">
                    <div className="title">Company Filters</div>
                  </div>
                  <div className="section-filters">
                    <div className="filter-item">
                      <CompanyName />
                    </div>
                    <div className="filter-item">
                      <EmpCount />
                    </div>
                    <div className="filter-item">
                      <Revenue />
                    </div>
                    <div className="filter-item dropdown-section">
                      <div
                        className="popup-file-upload "
                        onClick={e => setShowFileView('include')}
                      >
                        Include Companies
                        <DropDownIcon
                          className="dropdown-icon plus-icon"
                          width={14}
                          height={14}
                        />
                      </div>
                      <div
                        className={`file-upload-warp${
                          showFileView === 'include' ? ' showFile' : ''
                        }`}
                      >
                        <IncludeCompanyCSV setShowFileView={setShowFileView} />
                      </div>
                      {showFileView === 'include' && (
                        <div
                          className="suggestion-mask"
                          onClick={closeFileMask}
                        />
                      )}
                    </div>
                    <div className="filter-item dropdown-section">
                      <div
                        className="popup-file-upload "
                        onClick={e => setShowFileView('exclude')}
                      >
                        Exclude Companies
                        <DropDownIcon
                          className="dropdown-icon plus-icon"
                          width={14}
                          height={14}
                        />
                      </div>
                      <div
                        className={`file-upload-warp${
                          showFileView === 'exclude' ? ' showFile' : ''
                        }`}
                      >
                        <ExcludeCompanyCSV setShowFileView={setShowFileView} />
                      </div>
                      {showFileView === 'exclude' && (
                        <div
                          className="suggestion-mask"
                          onClick={closeFileMask}
                        />
                      )}
                    </div>

                    {/* <div className="filter-item">
                      <CompanyKeyword placeHolderText="Company Keywords" />
                    </div> */}
                    {CONTACT_PER_COMPANY_FILTER && (
                      <div className="filter-item">
                        <ContactPerCompany />
                      </div>
                    )}
                    <div className="filter-item">
                      <Technologies />
                    </div>
                  </div>
                </div>
                <div className="section-wrap">
                  <div className="section-title-wrap">
                    <div className="title">Email Status</div>
                    {(DIRECT_DIAL_FILTER ||
                      MOBILE_NUMBER_FILTER ||
                      ANY_PHONE_NUMBER_FILTER) && (
                      <div className="title">Phone Number Availability</div>
                    )}
                    <div className="title">Others</div>
                  </div>
                  <div className="section-filters">
                    <div className="filter-item">
                      <EmailPreference />
                    </div>
                    {(DIRECT_DIAL_FILTER ||
                      MOBILE_NUMBER_FILTER ||
                      ANY_PHONE_NUMBER_FILTER) && (
                      <div className="filter-item">
                        <PhoneCoverageFilter />
                      </div>
                    )}
                    <div className="filter-item">
                      <Options />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="popup-action-wrap">
            <Button
              btnText="Search"
              icon={false}
              iconName=""
              type="button"
              className="popup-action-btn positive-btn"
              loader={false}
              click={() => confirmClick()}
            />

            {showAppFilter && (
              <div
                className="popup-action-btn clear-btn"
                onClick={() => clearAllFilter()}
              >
                Clear All
              </div>
            )}
          </div>
        </div>
        <div
          className="popup-close"
          onClick={() => contactFilterPopupState.setShowPopup(false, true)}
        >
          <CloseIcon />
        </div>
      </div>
      <div
        className="common-popup-mask"
        onClick={() => contactFilterPopupState.setShowPopup(false, true)}
      />
    </>
  ) : (
    ''
  );
});

export { ContactFilterPopup, contactFilterPopupState };
export default ContactFilterPopup;
